import { useState } from "react";
import { useDispatch } from "react-redux";

const DownloadReportCSVButton = ({
    downloadMethod,
    params,
}) => {

    const dispatch = useDispatch();
    const [downloadLoading, setDownloadLoading] = useState(false);

    const handleDownloadCSV = async () => {
        console.log("Download CSV");
        try {
            setDownloadLoading(true);
            await dispatch(downloadMethod(params)).unwrap();

        } catch (error) {
            console.log(error);
        } finally {
            setDownloadLoading(false);
        }
    }

    return (
        <button
            disabled={downloadLoading}
            className={`btn btn-primary ms-2 btn-sm ${downloadLoading ? 'disabled' : ''}`}
            onClick={handleDownloadCSV}
            style={{
                width: '97px', // Fixed width
                height: '36px', // Fixed height
                opacity: downloadLoading ? 0.7 : 1, cursor: downloadLoading ? 'not-allowed' : 'pointer'
            }}
        >
            {downloadLoading ? (
                <>
                    {/* <div className="spinner-border spinner-border-sm me-2" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div> */}
                    <span style={{
                        // fontSize: '0.6rem',
                    }}>
                        Downloading...
                    </span>
                </>
            ) : (
                'Download CSV'
            )}
        </button>
    );
}

export default DownloadReportCSVButton;